"use client";

import { useAuth } from "@/providers/AuthProvider";
import { useCodiea } from "@codiea/tracking/react";
import { useEffect, useRef } from "react";

/**
 * Calls Codiea identify once per logged-in user (login or full page reload).
 * Mount inside AuthProvider.
 */
export function CodieaIdentify() {
  const { user } = useAuth();
  const { identify } = useCodiea();
  const identifiedUserId = useRef<string | null>(null);

  useEffect(() => {
    if (!user?.id) {
      identifiedUserId.current = null;
      return;
    }

    const userId = String(user.id);
    if (identifiedUserId.current === userId) return;

    identifiedUserId.current = userId;
    void identify({
      userId,
      traits: {
        email: user.email,
        name: user.name,
      },
    });
  }, [user, identify]);

  return null;
}
